export const getVersion = (state) => {
  return state.version
}

export const getBuild = (state) => {
  return state.build
}
